module.exports = __webpack_public_path__ + "img/p268.444453b1.png";